import type { FC } from 'react'
import { useTheme } from '@emotion/react'
import styled from '@emotion/styled'

import { AppearanceProvider } from '@segment/matcha/foundations/AppearanceContext'

import Footer from '@segment/templates/Footer'
import Navigation from '@segment/templates/Navigation'
import LogoCarousel from '@segment/templates/LogoCarousel'

import Layout from '@segment/next-shared/layout'

import Hero from './components/Hero'
import DeepenUnderstanding from './components/DeepenUnderstanding/DeepenUnderstanding'
import SelfServeAnalytics from './components/SelfServeAnalytics'
import DataScienceModeling from './components/DataScienceModeling'
import WhySegment from './components/WhySegment'
import TestimonialsSlider from './components/TestimonialsSlider'
import GetReady from './components/GetReady'
import LearnMore from './components/LearnMore'

const copy = {
  pageTitle: `Get Customer Insights | Twilio Segment`,
  pageDescription: `With clean, unified customer data, Twilio Segment can help you gain clear insights into your customer behavior, needs, and pain points.`,
}

const CustomerInsightsView: FC = () => {
  const theme = useTheme()

  return (
    <AppearanceProvider appearance="twilioLight">
      <Layout
        pageTitle={copy.pageTitle}
        pageDescription={copy.pageDescription}
        bodyBackground={theme.palette.neutrals.white[100]}
        themeColor={theme.palette.neutrals.white[100]}
      >
        <Navigation />
        <AppearanceProvider appearance="twilioDark">
          <Hero />
        </AppearanceProvider>
        <Main>
          <LogoCarouselWrapper>
            <LogoCarousel />
          </LogoCarouselWrapper>
          <DeepenUnderstanding />
          <SelfServeAnalytics />
          <DataScienceModeling />
          <WhySegment />
          <TestimonialsSlider />
          <GetReady />
          <LearnMore />
        </Main>
        <Footer />
      </Layout>
    </AppearanceProvider>
  )
}

const Main = styled.main``

const LogoCarouselWrapper = styled.div`
  padding: 80px 0;
  ${({ theme }) => theme.breakpoints.down(`md`)} {
    padding: 40px 0;
  }
`

export default CustomerInsightsView
